export default function getResource(label) {
    const resources = {
        faqs: 'FAQs',
        terms: 'Beauty Insider Terms & Conditions'
    };

    return resources[label];
}
